/**
 * SocialMediaStrip Functional Component
 * @Package - seo/Brand
 * @Author - Manila@UPWA-Team
 * @description: SocialMediaStrip (Brand Story)
 */

/**
 * Brand SEO 's SocialMediaStrip Component
 */
import React, { useMemo } from "react";
import { SocialMediaStrip as CPSocialMediaStrip } from "@usap/widgets";

export default function SocialMediaStrip({ dynamicApiData, apiDetails }) {
  const { props } = apiDetails;
  const { header, brandWidgets } = dynamicApiData;

  const brands = props.brands;
  const isBrandStore = dynamicApiData && brands.includes(header);

  if (!isBrandStore) return null;

  const data = useMemo(() => brandWidgets.socialMedia || [], [
    brandWidgets && brandWidgets.socialMedia
  ]);

  return <CPSocialMediaStrip id={`SocialMediaStrip`} data={data} />;
}
